import { Helmet } from 'react-helmet'
import {PhoneLink} from '../../components/Shared/Links'

export default function Pairing(){
  return (
    <div className="pageStyles pairing">
      <Helmet>
        <title>Wine Pairings at Villaggio Grille</title>
        <meta name="description" content="Every month, Villaggio Grille hosts a wine dinner showcasing a different vineyard. With the amazing dishes they create to accompany each wine, every dinner becomes a four-course experience that your taste buds will thank you for." />
      </Helmet>

      <div className="events-listing-page custStylePTA">
        <div id="page-title" className="pt-bkg-image image-events">
          <div className="overlay">
            <div className="container">
              <div className="row">
                <div className="title-container less">
                  <h1>September Wine Dinner</h1>
                  <h4 className="one">
                    September 24th &nbsp;&middot;&nbsp; 6pm 
                    <span className="rules"> &nbsp;&middot;&nbsp; </span>
                    <br className="rules" />
                    $60 Per Guest
                    <br className="fullBr" />
                    Featuring Ruffino Italian Wines
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="page-content">
          <div className="sectionWrap insideNrw food-menus no-padding">
            <div className="intro">
              <p className="res">For Reservations: <span><PhoneLink /></span></p>
            </div>
            <div className="clearfix"></div>
            <div className="col-md-8 center-block col-xs-12 hr-dec"><div className="hr hr-png-6"></div></div>
            <div className="clearfix"></div>
            
            <div className="course">
              <div className="service-box-2">
                <h3>Course One</h3>
                <h4>Pickled Vegetable Salad</h4>
                <h5>With House Cured Salmon Gravlax and Lemon Dill Cream</h5>
                <p>Paired with</p>
                <h4>Ruffino · Lumina Prosecco Rosé · D.O.C. of Italy '22</h4>
              </div>
            </div>
            <div className="col-md-8 center-block col-xs-12 hr-dec"><div className="hr hr-png-6"></div></div>
            <div className="clearfix"></div>

            <div className="course">
              <div className="service-box-2">
                <h3>Course Two</h3>
                <h4>Duck Two Ways</h4>
                <h5>Seared Duck Breast and Duck Confit Croquette · with Sweet Potato Puree, Pea Tendrils, and Dried Fig Jam</h5>
                <p>Paired with</p>
                <h4>Ruffino · Orvieto Classico · Umbria, Italy '24</h4>
              </div>
            </div>
            <div className="col-md-8 center-block col-xs-12 hr-dec"><div className="hr hr-png-6"></div></div>
            <div className="clearfix"></div>

            <div className="course">
              <div className="service-box-2">
                <h3>Course Three</h3>
                <h4>Blueberry Braised Beef</h4>
                <h5>With Parsnip Puree, Blistered Grape Tomatoes, and Cipollini Onions</h5>
                <p>Paired with</p>
                <h4>Ruffino · Toscana Modus · Tuscany, Italy '21</h4>
              </div>
            </div>
            <div className="col-md-8 center-block col-xs-12 hr-dec"><div className="hr hr-png-6"></div></div>
            <div className="clearfix"></div>

            <div className="course">
              <div className="service-box-2">                
                <h3>Course Four</h3>
                <h4>Plum Cobbler</h4>
                <h5>Sweet Ripe Plums, Greek Yogurt, and Honey</h5>
                <p>Paired with</p>
                <h4>Ruffino · Prosecco Organic · Veneto, Italy NV</h4>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="col-xs-12"><div className="hr hr-png-1"></div></div>
    </div>
  )
}
